// extracted by mini-css-extract-plugin
export var townLabel = "styles-module--townLabel--E_5aA";